import d from "./design-system.es90.js";
import { resolveComponent as u, openBlock as l, createElementBlock as a, Fragment as n, renderList as m, createBlock as i } from "vue";
import c from "./design-system.es128.js";
const s = {
  name: "DsRadioGroup",
  components: {
    Radio: d
  },
  props: {
    /**
     * Same as radio value
     */
    modelValue: [String, Number, Object],
    /**
     * Required value for validation
     */
    required: Boolean,
    /**
     * Name value for validation
     */
    name: String,
    /**
     * A list of options to render
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Value key if not default
     */
    valueProp: {
      type: String,
      default: "value"
    },
    /**
     * Label key if not default
     */
    labelProp: {
      type: String,
      default: "label"
    }
  },
  emits: ["update:modelValue"]
};
function v(o, p, e, b, f, _) {
  const t = u("Radio");
  return l(), a("div", null, [
    (l(!0), a(n, null, m(e.options, (r) => (l(), i(t, {
      key: r[e.valueProp],
      "model-value": e.modelValue,
      val: r[e.valueProp],
      label: r[e.labelProp],
      error: r.error,
      disabled: r.disabled,
      required: e.required,
      name: e.name,
      "onUpdate:modelValue": (P) => o.$emit("update:modelValue", r[e.valueProp])
    }, null, 8, ["model-value", "val", "label", "error", "disabled", "required", "name", "onUpdate:modelValue"]))), 128))
  ]);
}
const y = /* @__PURE__ */ c(s, [["render", v]]);
export {
  y as default
};
//# sourceMappingURL=design-system.es91.js.map
